// extracted by mini-css-extract-plugin
module.exports = {"data":"DataBlock_data__1E8gv"};